<script setup lang="ts">
import ProductTypeComponent from "@components/product-type.vue";
import {ProductsInterface} from "@interfaces/ProductsInterface.js";
import {PropType} from "vue";
import ButtonComponent from "@components/button.vue";
import {Link} from "@inertiajs/vue3";
import { trans } from "laravel-vue-i18n";

let props = defineProps({
  preConfigs: {
    type: Array as PropType<ProductsInterface[]>,
    required: true
  },
  categorySlug: {
    type: String,
    required: true
  },
  name: {
    type: Object as PropType<{ singular: string, plural: string }>,
    required: true
  }
});

</script>
<template>
  <section id="landing-section-products" class="container">
    <div class="grid">
      <article>
        <h2>
            {{ trans('sections.landing.our') + ' ' + props.name.plural }}
        </h2>
        <p>
          {{ trans('sections.landing.description') }}
        </p>
        <Link
            :href="route('preconfig.all')"
        >
          <button-component
              color="dark-slate"
          >
            {{ trans('sections.landing.discover_button') }}
          </button-component>
        </Link>
      </article>
      <product-type-component
          :category_slug="props.categorySlug"
          :product="preconfig"
          v-for="preconfig in props.preConfigs"
          :key="preconfig.id"
      >
      </product-type-component>
    </div>
  </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/landing/sections/products";
</style>
